import React, { useState, useReducer, useEffect } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { stage_promotion_types, stage_types, stage_categories } from '../../data/bootstrap_stages';
import { getStageName, i18nIntl, isNotEmpty } from '../../lib/ep.js';

import ActionButton, { BackButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import BuilderCanvas from '../builder/BuilderCanvas';
import BuilderSidebar from '../builder/BuilderSidebar';
import ButtonCollection from '../builder/ButtonCollection';
import Checkbox from '../builder/Checkbox';
import DisabledArea from '../builder/DisabledArea.js';
import DynamicFields from '../builder/DynamicFields.js';
import FloatingLayer from '../builder/FloatingLayer';
import Input from '../builder/Input';
import MediaUploader from '../builder/MediaUploader';
import Message from '../builder/Message';
import Model from '../builder/Model';
import { NavigationTabsBuilder } from '../builder/NavigationTabs';
import Range from '../builder/Range';
import RichEditor from '../builder/RichEditor';
import SaveButton from '../builder/SaveButton.js';
import SectionSubtitle from '../builder/SectionSubtitle.js';
import SectionTitle from '../builder/SectionTitle.js';
import Select from '../builder/Select';
import StagePicker from '../builder/StagePicker';
import Tooltip from '../builder/Tooltip';
import BuilderMain, { BuilderMainWithoutSidebar } from '../builder/BuilderMain';

import { GalleryNoRouter } from '../users/EntriesMultiGallery';

import Layout from '../front/Layout';

import VotingCandidateSelector from './VotingCandidateSelector.js';
import VotingCandidateManager from './VotingCandidateManager.js';

import transferPlaceholder from '../../hoc/transferPlaceholder';
import BuilderSubSectionTitle from './BuilderSubSectionTitle';
import CheckEnabler from '../builder/CheckEnabler';
import { AutoPostImageUploader } from '../builder/ImageUploader.js';
const RichPlaceHolder = injectIntl(transferPlaceholder(RichEditor));

const NO_STATUS = 'no_status';//Type 45, no te status open o closed o pending
const OPEN_STAGE = 'open';
const CLOSED_STAGE = 'closed';
const PENDING_STAGE = 'pending';

const CheckIcon = ({ status, ...props }) => {
	const _class = ['ep-check-list-item', ((status) ? 'greenIcon' : 'lightgrayIcon')];

	return (
		<span class={_class.join(" ")} />
	)
}

const VotingOriginSelector = ({ stage, stages, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [display_participant_picker, setDisplayParticipantPicker] = useState(false);
	const [display_layer, setDisplayLayer] = useState(true);

	const stage_candidates = [];
		stage_candidates.push(stage_promotion_types.MEDIA_CONTEST.id);//Multimedia Contest
		stage_candidates.push(stage_promotion_types.VOTING_CATEGORY.id);//Multimedia Gallery / Voting
		stage_candidates.push(stage_promotion_types.MEDIA_AUTOCONTENT.id);//Voting Contest
		stage_candidates.push(stage_promotion_types.PHOTOFUN.id);//Photofun
		stage_candidates.push(stage_promotion_types.SCENES.id);//Scenes

	const stages_electible = stages.filter((s) => (stage_candidates.map(String).includes(String(s.Stage.promotion_type_id)) && s.Stage.id != stage.id));
	
	const is_creating = (stage.voting_selection != undefined && stage.voting_selection) ? false : true;

	const [state, dispatch] = useReducer((state, action) => {
		switch(action.type) {
			case 'SET_METHOD':
				return { ...state, method:action.v };

			case 'SET_MIRROR':
				return { ...state, mirror:action.v, method:'' };

			case 'SET_TOTALS':
				return { ...state, totals:action.totals };

			default:
				return state;
		}
	}, {
		method:(!is_creating) ? 'partial' : '',
		mirror:'',
		ready:false,
		totals:{},
	});

	useEffect(() => {
		$.get(`/stages/get_totals/${stage.promotion_id}`, (response) => {
			dispatch({ type:'SET_TOTALS', totals:response });
		}, 'JSON');
	}, []);

	const selectMethod = (v) => {
		dispatch({ type:'SET_METHOD', v });
	};

	const setVotingMirror = (v) => {
		dispatch({ type:'SET_MIRROR', v });
	};

	const confirmMirrorCandidates = (cb) => {
		change('voting_mirror', state.mirror);

		$.post(`/stages/assign_vote_candidates/${stage.promotion_id}/${stage.id}`, { source:state.mirror }, () => {
			if(props.save != undefined) props.save();
			props.importEnded();
			if(cb != undefined) cb();
		});
	};

	const getStageStatus = (_stage) => {
		if(_stage == undefined) return false;
		const tz = props.promotion.timezone;
		const open = (moment.tz(_stage.start_date, tz).isBefore() && moment.tz(_stage.end_date, tz).isAfter()) ? true : false;
		const closed = (moment.tz(_stage.end_date, tz).isBefore()) ? true : false;
		const pending = (!open && !closed) ? true : false;
		if(_stage.promotion_type_id == stage_promotion_types.MEDIA_AUTOCONTENT.id )return NO_STATUS;
		if(open) return OPEN_STAGE;
		if(closed) return CLOSED_STAGE;
		return PENDING_STAGE;
	};

	const selected_stage = (state.mirror != '') ? stages_electible.find((s) => { return s.Stage.id == state.mirror; }).Stage : false;
	
	const available_stages = stages_electible.filter((obj) => {
		const stage = obj.Stage;
		const stage_type = stage_types.find((f) => { return f.id == stage.promotion_type_id });
		const stage_status = getStageStatus(stage);
		const media_stages = [
			stage_promotion_types.MEDIA_CONTEST.id, 
			stage_promotion_types.MEDIA_AUTOCONTENT.id,
			stage_promotion_types.PHOTOFUN.id,
			stage_promotion_types.SCENES.id
		];
		const is_voting_gallery = (stage.type == stage_categories.ID_VOTING_CATEGORY.id) ? true : false;

		// only display stages of upload new medias:
		if(is_voting_gallery) return false;

		// if method is "all", we only display the Album stages:
		if(state.method == 'all' && !media_stages.map(String).includes(String(stage_type.id))) return false;

		// if method is "partial", we only display the closed stages:
		//if(state.method == 'partial' && stage_status != 'closed' && stage_status != 'no_status') return false;

		return true;
	});

	const getParticipantsInStage = (stage_id) => {
		return (state.totals[stage_id] != undefined) ? state.totals[stage_id] : undefined;
	};
	
	if(!display_layer) return null;

	return (
		<FloatingLayer _class={{size:'fullscreen'}} enable_close={!is_creating} backButton={(!is_creating) ? () => props.importEnded() : null}>
			{(!display_participant_picker) && (
				<div class="without_actions">
					<div class="gui_section_header alone_section_header cleared_header">
						<SectionTitle _class={{other:'in_top'}}>Set up your Voting Gallery</SectionTitle>

						{(is_creating) && (
							<BackButton
								_href={`#stages/${stage.id}/options`}
							/>
						)}
					</div>

					<SectionSubtitle>Please select the candidates you want to display in the gallery for voting.</SectionSubtitle>

					<ul class="gui_guided_steps_configuration gui_not_in_top_big">
						<li>
							<p><CheckIcon status={(state.mirror != '') ? true : false} />1. {i18n("Origin of the candidates")}:</p>

							<div class="gui_item_picker visible_overflowed_container">
								{available_stages.length > 0 && available_stages.map((_stage, s) => {
									const stage = _stage.Stage;
									const stage_title = (stage.display_title != undefined && stage.display_title != "") ? stage.display_title : `[ ${i18n("Stage")} #${stage.id} ]`;
									const stage_type = stage_types.find((f) => { return f.id == stage.promotion_type_id });
									const participations = getParticipantsInStage(stage.id);
									const status = getStageStatus(stage);

									//if(status != NO_STATUS && status != CLOSED_STAGE) return null; //Acceptem 45, 36 Closed i 37 closed

									return (
										<StagePicker
											click_action={() => setVotingMirror(stage.id)}
											icon={(stage_type != undefined) ? stage_type.icon_class : 'knk-tiled-gallery'}
											is_selected={(stage.id == state.mirror) ? true : false}
											key={`stage_${stage.id}`}
											participations={participations}
											title={stage_title}
											description={stage.display_description}
											status={status}
										/>
									)
								})}

								{(available_stages.length == 0) && (
									<div class="nothing_to_select">
										{(state.method == 'all') && (
											(props.promotion.promotion_type_id == stage_promotion_types.MEDIA_AUTOCONTENT.id) ?(
												<>	
												<p><strong>{`${i18n("There are no candidates")}.`}</strong></p>
												<FormattedMessage id="You must add them through this {link}." values={{link:<ActionLink _href={`#stages/categories`}>tool</ActionLink>}} />
												</>
											) : (
												<p><strong>{i18n("There are no participants")}</strong></p>
											)
										)}

										{(state.method == 'partial') && (
											<p><strong>{i18n("There are no closed stages.")}</strong> {i18n("Please, wait until the stage closes, or close it manually modifying the stage dates.")}</p>
										)}
									</div>
								)}
							</div>
						</li>

						<li>
							<p><CheckIcon status={(state.method != '') ? true : false} />2. {i18n("How many?")}</p>
							<DisabledArea disabled={(state.mirror == '') ? true : false} message="First, select an origin">
								<div class={'gui_item_picker visible_overflowed_container' + ((state.method != '') ? ' with_selection' : '')}>
									<StagePicker
										click_action={() => selectMethod('all')}
										icon='knk-go-in'
										is_selected={(state.method == 'all') ? true : false}
										title={i18n("***All")}
										description={i18n("New candidates will appear automatically in the gallery.")}
									/>

									<StagePicker
										click_action={() => selectMethod('partial')}
										icon='knk-filter'
										is_selected={(state.method == 'partial') ? true : false}
										title={i18n("Subset")}
										description={i18n("Select a group of candidates to show.") + " " + i18n("For this option, the stage must be closed.")}
									/>
								</div>
							</DisabledArea>
						</li>

						<li>
							<p><CheckIcon status={false} />3. {i18n("Confirm and create the gallery")}:</p>

							<DisabledArea disabled={(state.mirror == '' || state.method == '') ? true : false} message="First, select how many">
								{(state.method != 'partial') && (
									<div class="gui_item_resumee">
										<div class="gallery_resumee">
											<p><FormattedMessage id="If you confirm, {total} candidates will show in the gallery." values={{total:getParticipantsInStage(state.mirror)}} /></p>
											<p>{i18n("All new participations will show automatically.")}</p>
										</div>

										<ButtonCollection _class={{other:'not_in_top'}}>
											<SaveButton
												color="green"
												onClick={(e, cb) => confirmMirrorCandidates(cb)}
											>Confirm</SaveButton>
										</ButtonCollection>
									</div>
								)}

								{(state.method == 'partial') && (
									<div class="gui_item_resumee">
										<div class="gallery_resumee">
											<p>{i18n("Continue to select the candidates that you want to show in the gallery.")}</p>
										</div>

										<ButtonCollection _class={{other:'not_in_top'}}>
											<ActionButton
												onClick={() => setDisplayParticipantPicker(true)}
											>Select the candidates</ActionButton>
										</ButtonCollection>
									</div>
								)}
							</DisabledArea>
						</li>
					</ul>
				</div>
			)}

			{(display_participant_picker) && (
				<VotingCandidateSelector
					stage={selected_stage}
					change={change}
					original_stage={stage}
					promotion={props.promotion}
					save={props.save}
					backButton={() => setDisplayParticipantPicker(false)}
					importEnded={props.importEnded}
				/>
			)}
		</FloatingLayer>
	);
}

const Tier = ({ model, change, ...props })=> {
	if(model.tier_score == undefined) model.tier_score = 1;

	if(props.type == 'ponderated') {
		return (
			<Model model={model} change={change} errors={props.errors && props.errors[model.id]}>
				<Input name="tier_score" _class={{size:60}}>Score</Input>
			</Model>
		);
	}

	return (
		<Model model={model} change={change} errors={props.errors && props?.errors[model.id]}>
			<Input name="tier_name" _class={{size:60}}>Tier Name</Input>
			<Input name="tier_score" _class={{size:60}}>Score</Input>
		</Model>
	);
}

let ranking_entries = [];
for(var i = 2; i <= 100; i++) {
	ranking_entries.push({ k:i, v:i });
}

const VotingGalleryBuilder = ({ stage, stages, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [tier_errors, setTierErrors] = useState({});

	const [is_creation_state, setCreationStage] = useState((stage.voting_mirror == undefined && stage.voting_selection == undefined) ? true : false);
	const [is_managing, setManageStage] = useState(false);

	const tierChange = (v) => {
		let errors = {};
		for(var i in v) {
			if(isNaN(v[i].tier_score)) {
				if(errors[`${v[i].id}`] == undefined) errors[`${v[i].id}`] = {};
				errors[`${v[i].id}`]['tier_score'] = i18n("It's not numeric");
			}
		}

		change('voting_tiers',v);
		setTierErrors(errors);
	};

	if(is_creation_state) {
		return (
			<BuilderMainWithoutSidebar pm={props.promoModel} has_tabs={true}>
				<NavigationTabsBuilder
					active={`${props.nav_active}`}
					sections={props.nav_sections}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<VotingOriginSelector
					change={change}
					importEnded={() => setCreationStage(false)}
					intl={props.intl}
					nav_active={props.nav_active}
					nav_sections={props.nav_sections || []}
					promotion={props.promotion}
					save={props.saveStage}
					stage={stage}
					stages={stages}
				/>
			</BuilderMainWithoutSidebar>
		)
	}

	if(is_managing) {
		return (
			<BuilderMainWithoutSidebar pm={props.promoModel} has_tabs={true}>
				<NavigationTabsBuilder
					active={`${props.nav_active}`}
					sections={props.nav_sections}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<FloatingLayer _class={{size:'fullscreen'}} backButton={() => setManageStage(false)}>
					<VotingCandidateManager
						intl={props.intl}
						promotion={props.promotion}
						stage={stage}
						backButton={() => setManageStage(false)}
					/>
				</FloatingLayer>
			</BuilderMainWithoutSidebar>
		)
	}

	const voting_types = [
		/*{ k:'', v:"-- " + i18n("Select a voting type") + " --" },*/
		{ k:'simple', v:i18n("Simple votes") + ": " + i18n("1 vote") + " = " + i18n("1 point") },
		{ k:'ponderated', v:i18n("Advanced votes") + ": " + i18n("1 vote") + " = " + i18n("X points") },
		//{ k:'tiered', v:i18n("Tiered Voting") },
	];

	const after_voting_actions = [
		{ k:'back', v:i18n("Back to gallery") + " (" + i18n("default") + ")" },
		{ k:'thanks', v:i18n("Continue to Thank you page") },
	];

	const gallery_orders = [
		{ k:'', v:`${i18n("From newest to oldest")} (${i18n("default")})` },
		{ k:'ID_ASC', v:i18n("From oldest to newest") },
		{ k:'NAME_ASC', v:`${i18n("Alphabetically by participant name")} (A-Z)` },
		{ k:'NAME_DESC', v:`${i18n("Alphabetically by participant name")} (Z-A)` },
		{ k:'RANDOM', v:i18n("Randomly") },
	];

	const gallery_proportions = [
		{ k:'15x12', v:`${i18n("default", 'ucfirst')} (15:12)` },
		{ k:'1x1', v:`${i18n("Square")} (1:1)` },
		{ k:'16x9', v:`${i18n("Landscape")} (16:9)` },
		{ k:'4x5', v:`${i18n("Portrait")} (4:5)` },
	];

	const toggleAddMode = () => {
		setCreationStage(!is_creation_state);
	};

	const toggleManage = () => {
		setManageStage(!is_managing);
	};

	const default_description_text = '<h1>' + i18n("Contest Gallery") + '</h1><p>' + i18n("These are the multimedia albums of the participants.") + '</p>';
	const default_thanks_voting_text = '<h1><strong>' + i18n("Done!") + '</strong></h1><p>' + i18n("Thank you for voting.") + '</p>';
	const video_url = (stage.main_video) ? stage.main_video.url : null;

	const is_voting_enabled = stage?.voting_enabled ?? false;
	const voting_type = stage?.voting_type ?? 'simple';

	if(voting_type == 'simple') {
		stage.voting_min = stage?.voting_min ?? 1;
		stage.voting_max = stage?.voting_max ?? 1;
	}

	let m_stage = false;
	if(stage.voting_mirror != undefined) {
		const _m_stage = stages.find((s) => (s.Stage.id == stage.voting_mirror));
		if(_m_stage != undefined) m_stage = _m_stage.Stage;
	}

	let public_name_display_options = [{ k:'1', v:`${i18n("The name of the participant")} (${i18n("default")})` }];
	let link_mirrored_stage = `#stages/${stage.voting_mirror}/media/settings`;
	if(m_stage !== false) {
		const extra_text_fields = (m_stage?.media_form ?? []).filter((f) => (f.type == 'field'));
		extra_text_fields.map((field) => {
			public_name_display_options.push({ k:field.id, v:`${i18n("The value of the extra field")}: ${field.title}` });
		});

		if(m_stage.promotion_type_id == stage_promotion_types.MEDIA_AUTOCONTENT.id){
			link_mirrored_stage = `#stages/categories/${stage.voting_mirror}`;
		}
	}

	return (
		<BuilderMain pm={props.promoModel}>
			<BuilderSidebar onSave={props.saveStage}>
				<NavigationTabsBuilder
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<article>
					{(stage.voting_mirror != undefined) && (
						<Message
							_class={{other:'in_top'}}
						>
							<p><FormattedMessage id="Origin of candidates: {stage}." values={{stage:<strong><ActionLink _href={link_mirrored_stage}>{getStageName(m_stage, i18n)}</ActionLink></strong>}} /></p>
						</Message>
					)}

					{(stage.voting_selection != undefined) && (
						<Message
							_class={{other:'in_top'}}
						>
							<div class="gui_link_actions">
								<ActionLink onClick={toggleAddMode}>Add new entries</ActionLink>
								<ActionLink onClick={toggleManage}>Remove entries</ActionLink>
							</div>
						</Message>
					)}

					<Model model={stage} change={change}>
						<MediaUploader
							imageField="main_image"
							videoField="main_video"
							image={stage.full_main_image}
							video={video_url}
							_class={{first:true}}
						>Upload media</MediaUploader>

						<RichPlaceHolder
							placeholder={default_description_text}
							name="main_description"
							has_emojis={true}
						>Introduction message</RichPlaceHolder>

						{/*<Checkbox
							name="gallery_hide_username"
						>Hide names and dates in participations</Checkbox>*/}

						<CheckEnabler
							label="Display candidate name"
							enabled={((stage?.voting_public_name_display ?? '1') != '0') ? true : false}
							onEnable={() => {
								change('voting_public_name_display', '1');
							}}
							onDisable={() => {
								change('voting_public_name_display', '0');
							}}
						>
							<Select
								name="voting_public_name_display"
								model={stage}
								change={change}
								values={public_name_display_options}
								value={stage?.voting_public_name_display ?? '1'}
								_class={{ size:60 }}
							>Name field origin</Select>
						</CheckEnabler>

						<Checkbox
							name="voting_user_avatar"
						>Display candidate avatar</Checkbox>

						<Checkbox
							name="voting_user_created"
						>Display candidate date</Checkbox>

						<Checkbox
							name="voting_user_country"
						>Display candidate country</Checkbox>

						<Select
							name="gallery_order"
							value={stage?.gallery_order ?? ""}
							values={gallery_orders}
						>Order of candidates in the gallery</Select>

						<Select
							name="gallery_proportion"
							value={stage?.gallery_proportion ?? "15x12"}
							values={gallery_proportions}
							_class={{ size:50 }}
						>Aspect ratio</Select>

						{/* REMOVED ON 2023-10-20 */}
						{/*<Checkbox
							name="voting_public"
						>Gallery is visible to not logged in users (visitors)</Checkbox>*/}

						<Checkbox
							name="voting_display_toolbar"
							value={stage?.voting_display_toolbar ?? true}
						>Display tools (total entries and search field)</Checkbox>
					</Model>
				</article>

				<article class="gui_not_in_top_huge">
					<BuilderSubSectionTitle
						title="Voting"
						icon='knk-like'
					/>

					<Model model={stage} change={change}>
						<Checkbox
							name="voting_enabled"
							value={is_voting_enabled}
						>Enable voting system</Checkbox>
					</Model>

					{(is_voting_enabled) && (
						<Model model={stage} change={change}>
							{/* REMOVED ON 2023-10-20 */}
							{/*<Checkbox
								name="voting_jury_mode"
								label_props={{
									tooltip:<Tooltip position='top' link={`${window.zendesk_base_url}4407268022804`}>Enable this option only if access and votes for this gallery are limited to a group of users who are juries. Click here to learn how to configure a gallery for juries.</Tooltip>,
								}}
							>Jury mode</Checkbox>*/}

							{(m_stage && m_stage.promotion_type_id != stage_promotion_types.MEDIA_AUTOCONTENT.id) && (//Mirror stage
								<Checkbox
								name="voting_self_unallowed"
								>Participant cannot vote for self</Checkbox>
							)}

							<Checkbox
								name="voting_enable_ranking"
							>Publish the number of votes and the ranking of the most voted</Checkbox>

							<RichPlaceHolder
								placeholder={default_description_text}
								name="voting_ranking_description"
								has_emojis={true}
							>Ranking page introduction message</RichPlaceHolder>

							<AutoPostImageUploader
								auto_url={`/promotions/auto_img/${stage.promotion_id}`}
								auto_type='stages'
								name="voting_ranking_image"
								image={stage?.full_voting_ranking_image}
								display_custom_dragging_instructions="Upload the image"
								small_input={true}
								_size={{ fit:'auto' }}
							>Ranking page image</AutoPostImageUploader>

							<Select
								name="voting_ranking_entries"
								_class={{size:30}}
								values={ranking_entries}
								value={stage?.voting_ranking_entries ?? 10}
							>Number of entries in ranking</Select>

							<Select
								name="voting_type"
								_class={{ size:60 }}
								values={voting_types}
							>Voting type</Select>


							{/*(voting_type == 'simple') && (
								<Checkbox
									name="voting_enable_fraud"
								>Enable the detection of fradulent voting patterns</Checkbox>
							)*/}

							{/* {(voting_type == 'simple') && (
								<Range
									min={1}
									max={10}
									name="voting_min"
									value={stage.voting_min}
									default={1}
									step={1}
									_class={{size:40}}
								>Min. entries to vote</Range>
							)}

							{(voting_type == 'simple') && (
								<Range
									min={stage.voting_min}
									max={10}
									name="voting_max"
									value={stage.voting_max}
									default={1}
									step={1}
									_class={{size:40}}
								>Max. entries to votes</Range>
							)} */}
						</Model>
					)}

					{(is_voting_enabled && voting_type == 'tiered') && (
						<DynamicFields
							fields={stage.voting_tiers || []}
							field_types={[
								{
									type:'tier',
									icon:'knk-options-list',
									label:"Add a new tier",
									main_field:'tier_name',
									title:(f) => {
										const score_display = " (" + ((f.tier_score != undefined && f.tier_score != "") ? f.tier_score : "1") + ")";
										return ((f.tier_name != undefined && f.tier_name != "") ? f.tier_name : i18n("Tier field")) + score_display;
									},
								}
							]}
							onChange={tierChange}
							section_classes="gui_not_in_top_huge"
							section_title={i18n("Voting tiers")}
							section_icon="knk-like"
							sortable={true}>
							<Tier errors={tier_errors} />
						</DynamicFields>
					)}

					{(is_voting_enabled && voting_type == 'ponderated') && (
						<DynamicFields
							fields={stage.voting_tiers || []}
							field_types={[{
								type:'tier',
								icon:'knk-options-list',
								label:"Add new tier",
								main_field:'tier_score',
								title:(f) => {
									const score_display = (f.tier_score != undefined && f.tier_score != "") ? f.tier_score : "1";
									return props.intl.formatMessage({ id:"{num} points" }, { num:score_display });
								}
							}]}
							onChange={tierChange}
							section_classes="gui_not_in_top_huge"
							section_title={i18n("Points tiers")}
							section_icon="knk-like"
							sortable={true}
						>
							<Tier errors={tier_errors} type={stage.voting_type} />
						</DynamicFields>
					)}
				</article>

				{(is_voting_enabled && voting_type != 'simple') && (
					<article class="gui_not_in_top_huge">
						<BuilderSubSectionTitle
							title="After voting"
							icon='knk-like'
						/>

						<Model model={stage} change={change}>
							<RichPlaceHolder
								placeholder={default_thanks_voting_text}
								name="voting_success_label"
								has_emojis={true}
							>After voting message</RichPlaceHolder>

							<Select
								name="after_voting_action"
								values={after_voting_actions}
							>After voting action</Select>
						</Model>
					</article>
				)}
			</BuilderSidebar>

			<BuilderCanvas is_adaptable={true} fit_to_window="content">
				<Layout promo={props.promotion} is_builder={true} page="landing" menus={props.promoModel.Custom__Menus}>
					<div class="__gui_withoutEvents" style={{width:'100%'}}>
						<GalleryNoRouter
							stage={stage}
							is_builder={true}
							promotion={props.promotion}
							base_route="/promotions/participate/"
							votingSubmit={() => {}}
						/>
					</div>
				</Layout>
			</BuilderCanvas>
		</BuilderMain>
	);
}

export default injectIntl(VotingGalleryBuilder);